import { Button } from '@material-tailwind/react'
import React, { useEffect, useRef } from 'react'
import ArrowAccordionIcon from '../../images/icons/ArrowAccordionIcon'


export const handleScrollToId = (target: string = '') => {
    let top = document.getElementById(target)?.offsetTop ? document.getElementById(target)?.offsetTop : 0
    if (!top) top = 0
    window.scrollTo({
        top: top - 180,
        behavior: 'smooth'
    })
}

const ButtonMoveTop = () => {

    const button = useRef<any>(null)

    useEffect(() => { 
        window.addEventListener("scroll", changeVisible); 
        return () => {
            window.removeEventListener('scroll', changeVisible)
        }
    }, [])

    const changeVisible = () => {
        if (button?.current) {
            // console.log(window.pageYOffset, window.innerHeight)
            if (window.pageYOffset > window.innerHeight) {
                button.current.classList.add("show-btn-to-top");
                button.current.classList.remove("hide-btn-to-top");
            } else {
                button.current.classList.remove("show-btn-to-top");
                button.current.classList.add("hide-btn-to-top");
            }
        }
    }

    return (
        <div className='fixed bottom-[96px] lap:bottom-[30px] right-[16px] lap:right-[24px] flex justify-end'>
            <Button
                ref={button}
                color='white'
                className='hide-btn-to-top group p-[14px] w-[48px] h-[48px] rounded-full lap:rounded-[8px] flex items-center justify-center border-[1px] border-gray-200 shadow-lg hover:bg-black hover:border-black ease-in-out duration-200  transition-all'
                onClick={() => {
                    handleScrollToId('top')
                }}
            >
                <ArrowAccordionIcon className='group-hover:fill-white transition-all' />
            </Button>
        </div>
    )
}

export default ButtonMoveTop